import { FC } from 'react';
import { Widget } from '../../widget';
import DecayContent from './decay-content';
import { DecayProps } from './types';

const DecayWidget: FC<DecayProps> = (props) => {
  const { widget, dataType, currency } = props;
  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
      </Widget.Header>
      <Widget.Content>
        <DecayContent dataType={dataType as 'deltaDecay' | 'thetaDecay'} currency={currency} />
      </Widget.Content>
      <Widget.Footer />
    </Widget>
  );
};

export default DecayWidget;
